<template>
    <div>
            <div class="row my-3">

              <div class="col col-md-6">
                <div class="form-group" :class="{'required': isDateRequired}">
                  <label class='control-label'>Дата приема врача</label>
                  <date-component :disabled="isReadonly" v-model="date" />
                  <div class="invalid-msg" v-if="v$.date.$error">Введите корректную дату</div>
                </div>
              </div>

              <div class="col col-md-6">
                <div class="form-group" :class="{'required': isDateRequired}">
                  <component-input type="time" :disabled="isReadonly" v-model="time" id="time"  label="Время приема врача"/>
                  <div class="invalid-msg" v-if="v$.time.$error">Введите корректное время</div>
                </div>
              </div>

              <div class="col col-md-12">
                <div class="form-group required">
                  <label class='control-label'>Статус</label>
                  <select class="form-control" v-model="item.status">
                    <option v-for="el in statusList" v-bind:key="el.id" :value="el.id">{{ el.text }}</option>
                  </select>
                </div>
              </div>

              <div class="col col-md-12">
                <div class="form-group">
                  <component-input type="text" :disabled="isReadonly" v-model="item.statusComment" label="Комментарий" />
                </div>
              </div>

              <div class="col col-md-12" v-if="viewFile">
                <div class="form-check my-3">
                  <component-input
                    label="Согласие на внесение в Регистр ЛРАС"
                    v-model="item.agree"
                    id="chAgree"
                    type="checkbox"
                    scopeName="general"
                    :disabled="item.status != 6"
                  />
                </div>
                <!-- <div class="form-group">
                            <label class='control-label'>Согласие на включение в Регистр</label>
                            <file-upload width="100%" :entity="item"
                                @deleteFile="removeFile"
                                prop-name="file"
                                :readonly="item.status != 6"
                                @uploaded="fileUploaded"/>
                            </div> -->
              </div>

            </div>

            <div>
              <div class="float-right d-flex">
                <button-component v-if="!isReadonly" class="btn  btn-primary mx-2" v-on:click="save">Сохранить</button-component>
                <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">Закрыть</button-component>
              </div>
             </div>

    </div>
</template>
<script>
import API from '../api/poll'
import Constants from '@/common/constants'
import { requiredIf } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import DateComponent from "@/common/components/DateComponent"
import Inputmask from 'inputmask';
import ButtonComponent from "@/common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput";
import security from "@/common/mixins/security";
import Utils from "@/common/utils";
//import FileUpload from "@/common/components/FileUpload";

const timeValidator = (value) => value === null || value === undefined || value === '' || new RegExp("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$", "g").test(value);

export default {
  name: "TmpPatientStatusCard",
  props: {
    tmpPatient:Object
  },
  components: {
      ComponentInput,
      ButtonComponent,
      DateComponent,
      //FileUpload
  },
  mixins: [security],
  created() {
      if (this.tmpPatient) {
          this.date = this.tmpPatient.dateVisitDoctor;
          this.time = this.tmpPatient.dateVisitDoctor ? this.tmpPatient.dateVisitDoctor.substring(11, 16) : null;
          this.item = Object.assign({}, this.tmpPatient);
          this.dateEdit = this.item.status > 0;
      }
    this.checkPermission(Constants.PatientEdit).then((response) => { this.isReadonly = !response.data });
    Utils.loadSelectOptions("tmpPatientStatus", this.statusList, {currStatus: this.item.status});
  },
  mounted() {
    // ... используем
    var im = new Inputmask("99:99");
    im.mask(document.getElementById('time'));
  },
  computed: {
      isDateVisit() {
        if(this.date != null && this.time != null) {
            var t = this.date + "T" + this.time + ":00";
            //console.log(t, (new Date()).toISOString());
            return t <  (new Date()).toISOString();
        }
        return false;
      },
      isDateRequired() {
        return this.item.status && this.item.status != 5 && this.item.status != 4;
      },
      viewFile() {
        return this.item.status == 1 || this.item.status == 9 
          || (this.item.status == 6 && this.item.dateVisitDoctor && this.item.dateVisitDoctor < (new Date()).toISOString());
      }
  },
  data() {
    return {
        item: {

        },
        date: null,
        time: null,
        statusList: [],
        isReadonly: false
    };
  },
  methods: {
    save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error' );
          return;
        }

        var dateEnter = null; 
        if(this.date != null)
          dateEnter = this.date + "T" + (this.time != null ? this.time : "00:00") + ":00";

        this.item.dateVisitDoctor = dateEnter;
        if(this.item.dateVisitDoctor >=  (new Date()).toISOString())
            this.item.status = 0;

        API.changeStatus(this.item).then((response) => {
            Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error' );
            if(response.data.success) {
                //var statusName = this.statusList.find(x => x.id == this.item.status).text;
                API.find(this.item.id).then((res) => {
                  console.log(res.data);
                  this.$emit('save', res.data);
                });
                // var r = Object.assign({}, this.item);
                // r.statusName = response.data.message;//.toLowerCase();
                // this.$emit('save', r);
            }
        });
    },    
    close() {
      this.$emit('close');
    },
    removeFile() {
        this.item.fileId = null
    },
    fileUploaded(e) {
        this.item.file = e.data;
        this.item.fileId = e.data ? e.data.id : null;
    }
  },
  setup: () => ({ v$: useVuelidate() }),
  validations () {
    return {
        date: { required: requiredIf(function () {
            return this.isDateRequired;
          }) },
        time: { required: requiredIf(function () {
            return this.isDateRequired;
          }), timeValidator },
    }
  }
}; 
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.form-group.required .control-label:after { 
   content:"*";
   color:red;
}
.form-check.required .control-label:after { 
   content:"*";
   color:red;
}
.invalid-msg {
  color:red;
  font-size: 0.75rem;
}
.control-label{
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
}
</style>
